



















import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
class MiniPoster extends Vue {
  @Prop({ type: String, default: "" }) img!: string;
  @Prop({ type: String, required: true }) folder!: string;
}
export default MiniPoster;
